export var GameStatus;
(function (GameStatus) {
    GameStatus["Ready"] = "READY";
    GameStatus["InProgress"] = "IN PROGRESS";
    GameStatus["Complete"] = "COMPLETE";
    GameStatus["Abandoned"] = "ABANDONED";
})(GameStatus || (GameStatus = {}));
//# sourceMappingURL=GameState.js.map